export default __webpack_public_path__ + "static/media/CIRlogo.f43db96b.svg";